import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function GraficaTemperatura({ timeRange = 'day', temperaturas = null, tiempos = null }) {

  const noData = tiempos === null || !temperaturas || temperaturas.every(temp => temp === null) ;

  if (noData) {
    return <div style={{ textAlign: 'center', padding: '20px', color: '#666', fontStyle: 'italic',}}>
      No hay datos de temperatura en este rango de fechas.
    </div>;
  }

  const chartData = {
    labels: tiempos,
    datasets: [
      {
        label: 'Temperatura (°C)',
        data: temperaturas,
        borderColor: '#36A2EB',
        backgroundColor: '#36A2EB',
        tension: 0.3,
        borderWidth: 2, // Grosor de la línea
        pointRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: 'Temperatura (°C)'
        }
      },
      x: {
        title: {
          display: true,
          text: timeRange === 'day' ? 'Hora del día' : (timeRange === 'week' ? 'Día de la semana' : 'Dias del mes')
        }
      }
    },
  };

  return <Line data={chartData} options={options} />;
}